import * as z from 'zod';
import { BILLING_CYCLES, BILLING_TIME } from 'src/features/servicePlanBillingPolicies/utils/types';

export type ServicePlanBillingPolicyFormSchemaValues = z.infer<typeof servicePlanBillingPolicyFormSchema>;
export const servicePlanBillingPolicyFormSchema = z.object({
    valid_from: z.string(),
    billing_cycle: z.enum(BILLING_CYCLES),
    billing_time: z.enum(BILLING_TIME),
    valid_to: z.string().optional().nullable(),
    enable_proration: z.boolean(),
});

export type PatchServicePlanBillingPolicyFormSchemaValues = z.infer<typeof patchServicePlanBillingPolicySchema>;
export const patchServicePlanBillingPolicySchema = servicePlanBillingPolicyFormSchema.partial();
